module.exports = __webpack_public_path__ + "static/media/long-program.6e4f4920.png";